import React , { useState ,useEffect } from 'react';
import './styles.scss';
import { Link } from 'react-router-dom';

import img from '../../assets/images/logo/log-footer.png'
import img1 from '../../assets/images/logo/logo-footer-dark.png'
import ReloadableLink from '../../pages/Reload';


function Footer(props) {

    const [productLink] = useState([
        {
            title: 'Launchpad',
            path: '/launchpad',
            icon: 'fa-solid fa-rocket'
        },
        {
            title: 'Airdrop',
            path: '/airdrop',
            icon: 'fa-solid fa-parachute-box'
        },
        {
            title: 'Staking',
            path: '/staking',
            icon: 'fa-solid fa-coins'
        },
        {
            title: 'Cetoex News',
            path: '#',
            icon: 'fa-solid fa-newspaper'
        },
       
       
      
    ]);

    const [servicesLink] = useState([
       
        {
            title: 'FAQ',
            path: '/faq',
            icon: 'fa-solid fa-circle-question'
        },
        {
            title: 'List Your Coin',
            path: '/coin-listing',
            icon: 'fa-solid fa-list-ul'
        },
        {
            title: 'Fee Schedule',
            path: '/fee-schedule',
            icon: 'fa-solid fa-receipt'
        },
        {
            title: 'API Documentation',
            path: 'https://docs.cetoex.com',
            icon: 'fa-solid fa-code'
        },
        {
            title: 'Referral Program',
            path: '/referral-program',
            icon: 'fa-solid fa-users'
        },
       
    ]);

    const [companyLinks] = useState([
        {
            title: 'About Us',
            path: '/about',
            icon: 'fa-solid fa-building'
        },
        {
            title: 'Official Verification',
            path: '/official-authenticity',
            icon: 'fa-solid fa-user-shield'
        },
        {
            title: 'Terms of Use',
            path: '/terms-of-use',
            icon: 'fa-solid fa-file-contract'
        },
        {
            title: 'Privacy Policy',
            path: '/privacy',
            icon: 'fa-solid fa-shield'
        },
       
        {
            title: 'Contact Us',
            path: '/contact',
            icon: 'fa-solid fa-headset'
        },
    ]);

    const [listSocial] = useState([
        {
            icon: 'fa-brands fa-twitter',
            path: 'https://twitter.com/Cetoex',
            name: 'Twitter'
        },
        {
            icon: 'fa-solid fa-paper-plane',
            path: 'https://t.me/CetoEXExchange',
            name: 'Telegram'
        },
        {
            icon: 'fa-brands fa-instagram',
            path: 'https://www.instagram.com/cetoex/',
            name: 'Instagram'
        },
        {
            icon: 'fa-brands fa-youtube',
            path: 'https://www.youtube.com/@Cetoex',
            name: 'YouTube'
        },
        {
            icon: 'fa-brands fa-facebook',
            path: 'https://www.facebook.com/cetoex',
            name: 'Facebook'
        },
        {
            icon: 'fa-brands fa-github',
            path: 'https://github.com/cetoex',
            name: 'GitHub'
        },
        {
            icon: 'fa-brands fa-discord',
            path: '#',
            name: 'Discord'
        },
        {
            icon: 'fa-brands fa-linkedin',
            path: '#',
            name: 'LinkedIn'
        },
    ])
    

    const [isVisible, setIsVisible] = useState(false);

    const scrollToTop = () => {
      window.scrollTo({
        top: 0,
        behavior: "smooth"
      });
    };
  
    useEffect(() => {
      const toggleVisibility = () => {
        if (window.pageYOffset > 500) {
          setIsVisible(true);
        } else {
          setIsVisible(false);
        }
      };
  
      window.addEventListener("scroll", toggleVisibility);
  
      return () => window.removeEventListener("scroll", toggleVisibility);
    }, []);

    return (
                <footer className="footer modern-footer">
            {/* Main Footer Content */}
            <div className="footer__main">
                <div className="container">
                 

                    {/* Middle Section with Links */}
                    <div className="footer__middle">
                        <div className="row">
                            <div className="col-lg-3 col-md-6">
                                <div className="footer__widget">
                                    <h6 className="widget-title">
                                        <i className="fa-solid fa-rocket"></i>
                                        Products
                                    </h6>
                                    <ul className="widget-links">
                                        {productLink.map((data, idx) => (
                                            <li key={idx}>
                                                <Link to={data.path} className="link-item">
                                                    <i className={data.icon}></i>
                                                    <span>{data.title}</span>
                                                </Link>
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                            </div>
                            
                            <div className="col-lg-3 col-md-6">
                                <div className="footer__widget">
                                    <h6 className="widget-title">
                                        <i className="fa-solid fa-gear"></i>
                                        Services
                                    </h6>
                                    <ul className="widget-links">
                                        {servicesLink.map((data, idx) => (
                                            <li key={idx}>
                                                <Link to={data.path} className="link-item">
                                                    <i className={data.icon}></i>
                                                    <span>{data.title}</span>
                                                </Link>
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                            </div>

                            <div className="col-lg-3 col-md-6">
                                <div className="footer__widget">
                                    <h6 className="widget-title">
                                        <i className="fa-solid fa-building"></i>
                                        Company
                                    </h6>
                                    <ul className="widget-links">
                                        {companyLinks.map((data, idx) => (
                                            <li key={idx}>
                                                <Link to={data.path} className="link-item">
                                                    <i className={data.icon}></i>
                                                    <span>{data.title}</span>
                                                </Link>
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                            </div>

                            <div className="col-lg-3 col-md-6">
                                <div className="footer__widget contact-widget">
                                    <h6 className="widget-title">
                                        <i className="fa-solid fa-headset"></i>
                                        Support
                                    </h6>
                                    <div className="contact-info">
                                        <div className="contact-item">
                                            <i className="fa-solid fa-comments"></i>
                                            <div>
                                                <span className="label">24/7 Live Chat</span>
                                                <p>Get instant support</p>
                                            </div>
                                        </div>
                                        <div className="contact-item">
                                            <i className="fa-solid fa-envelope"></i>
                                            <div>
                                                <span className="label">Email Support</span>
                                                <p>support@cetoex.com</p>
                                            </div>
                                        </div>
                                        <div className="contact-item">
                                            <i className="fa-solid fa-location-dot"></i>
                                            <div>
                                                <span className="label">Headquarters</span>
                                                <p>Dubai, United Arab Emirates</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>


                    </div>
            </div>

            {/* Footer Bottom */}
            <div className="footer__bottom">
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-lg-6">
                            <div className="footer__copyright">
                                <p>
                                    <i className="fa-regular fa-copyright"></i>
                                    {new Date().getFullYear()} CetoEX Exchange. All rights reserved.
                                </p>
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div className="footer__social">
                                <span className="social-label">Follow us:</span>
                                <ul className="social-links">
                                    {listSocial.map((data, idx) => (
                                    <li key={idx}>
                                            <a 
                                                href={data.path} 
                                                className="social-link" 
                                                target="_blank" 
                                                rel="noopener noreferrer"
                                                title={data.name}
                                            >
                                                <i className={data.icon}></i>
                                            </a>
                                    </li>
                                    ))}
                        </ul>
                    </div>
                    </div>
                </div>
                </div>
            </div>

            {/* Scroll to Top Button */}
            {isVisible && (
                <button onClick={scrollToTop} className="scroll-to-top" aria-label="Scroll to top">
                    <i className="fa-solid fa-arrow-up"></i>
                </button>
            )}
        </footer>
    );
}

export default Footer;